/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminReactionsEmojiDefinitionResponseV4FromJSON, InternalAdminReactionsEmojiDefinitionResponseV4ToJSON, } from './InternalAdminReactionsEmojiDefinitionResponseV4';
import { CommonResponseCollectionPaginationFromJSON, CommonResponseCollectionPaginationToJSON, } from './CommonResponseCollectionPagination';
/**
 * Check if a given object implements the InternalAdminReactionsEmojiDefinitionResponseCollectionV4 interface.
 */
export function instanceOfInternalAdminReactionsEmojiDefinitionResponseCollectionV4(value) {
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
export function InternalAdminReactionsEmojiDefinitionResponseCollectionV4FromJSON(json) {
    return InternalAdminReactionsEmojiDefinitionResponseCollectionV4FromJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionResponseCollectionV4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': CommonResponseCollectionPaginationFromJSON(json['pagination']),
        'data': (json['data'].map(InternalAdminReactionsEmojiDefinitionResponseV4FromJSON)),
    };
}
export function InternalAdminReactionsEmojiDefinitionResponseCollectionV4ToJSON(json) {
    return InternalAdminReactionsEmojiDefinitionResponseCollectionV4ToJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionResponseCollectionV4ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pagination': CommonResponseCollectionPaginationToJSON(value['pagination']),
        'data': (value['data'].map(InternalAdminReactionsEmojiDefinitionResponseV4ToJSON)),
    };
}
